import * as http from "../../index";
import Configuration from "../../../config/index";
export const requestCaseStatus = (caseId) => {
    const host = Configuration.current().getApiAddress();
    const url = `${host}/credit-assessment/${caseId}`;
    const forgeryToken = http.context().requestForgeryToken;
    const request = http
        .builder()
        .method("get")
        .accept("application/json")
        .requestForgeryToken(forgeryToken)
        .build();
    return http.captureStateContext(http.json(url, request));
};
